import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import SimpleBoxDisplay from "../../../../common/SimpleBoxDisplay";
import CaseSummaryBox from "../CaseSummaryBox";

export default function CrimeVictimSummary({primaryCrimeVictim, classes}) {

    return <>
        {primaryCrimeVictim && primaryCrimeVictim.filled_by_patient ? <CaseSummaryBox title={'Crime Victim'} tabNumber={4} >
            <>
                <div className={classes.row}>
                    
                    {primaryCrimeVictim.approved == null && <CheckboxCell checked={true} label={'Submitted'} isDisabled={true} direction={'reverse'} />}
                    {primaryCrimeVictim.approved == 1 && <>
                        {primaryCrimeVictim.exhausted ? <CheckboxCell checked={true} label={'Exhausted'} isDisabled={true} direction={'reverse'} /> : <CheckboxCell checked={true} label={'Approved'} isDisabled={true} direction={'reverse'} />}
                    </>}
                    {primaryCrimeVictim.approved == 0 && <>
                        {primaryCrimeVictim.appealed ? <CheckboxCell checked={true} label={'Appealed'} isDisabled={true} direction={'reverse'} /> : <CheckboxCell checked={true} label={'Denied'} isDisabled={true} direction={'reverse'} />}
                    </>}
                </div>
                <div className={classes.row}>
                    <SimpleBoxDisplay label={'Amount of Statement Submitted ($)'} value={primaryCrimeVictim.amount_submitted ? primaryCrimeVictim.amount_submitted : '-'}/>      
                </div>
            </>
        </CaseSummaryBox> : ''}
    </>
}